import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell } from '@fortawesome/free-regular-svg-icons'
import { faHandHoldingDollar, faSackDollar, faGear, faArrowRightFromBracket, faBars } from '@fortawesome/free-solid-svg-icons'
import SidebarItem1 from "./SidebarItem1";
import { Toaster, toast } from 'react-hot-toast';
import { useUser } from "../utils/UserContext";

function Header({title, icon, toggleSidebar, toggleNotification, toggleSettingsBar }) {
  const [profileInfo, setProfileInfo] = useState("closed")
  const [notifications, setNotifications] = useState([])
  const { user, setUser } = useUser();
  const logout = () => {
    fetch(`${process.env.REACT_APP_API_URL}controller/logout.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ logout: true})
    })
    .then(response => response.text())
    .then(data => {
      console.log(data);
      if (data === "success") {
        setUser(null); // clear user
        window.location.href = "login";
      }else{
        toast.error("Logout failed");
      }
    })
    .catch(err => {
      console.error(err)
    }) 
  };
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchNotification: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setNotifications(data.notifications);
      }
    })
    .catch(err => {
      console.log(err);
        console.error('Error fetching signals!')
    })
  }, [user]);
  return (
    <>
      <Toaster/>
      <header className="header">
          <FontAwesomeIcon icon={faBars} className="d-block d-md-none" style={{color: 'gray', cursor: 'pointer', fontSize: '22px'}} onClick={toggleSidebar}/>
          <div className="d-md-flex d-none align-items-center">
              {icon}
              <span className="ms-2 fw-bold" style={{fontSize: '16px'}}>{title}</span>
          </div>
          <div className="d-flex align-items-center">
              <div className="position-relative d-flex align-items-center justify-content-center notify" 
              style={{ width: "32px", height: "32px", borderRadius: '6px', cursor: 'pointer' }}
              onClick={toggleNotification}
              >
                  <FontAwesomeIcon icon={faBell} style={{fontSize: '18px'}} />
                  <span
                  className="position-absolute translate-middle badge rounded-pill bg-danger"
                  style={{ fontSize: "0.5rem", top: '5px', right: '-5px' }}
                  >{notifications.length > 9 ? "9+" : notifications.length}</span>
              </div>
              <div
                className="d-flex align-items-center justify-content-center ms-4 rounded-2 overflow-hidden"
                style={{ width: "32px", height: "32px", backgroundColor: '#ffffff0d', borderRadius: '6px', color: '#f80', cursor: 'pointer' }}
                onClick={() => {
                  setProfileInfo(profileInfo === "closed" ? "open" : "closed");
                }}
              >
                {user.photo == "" ? (
                    <span className="fw-semibold">{user?.fullname?.substring(0, 2)}</span>
                ) : (
                    <img src={`/uploads/${user.photo}`} alt="profile" className="w-100 h-100" style={{objectFit: 'cover'}}/>
                )}  
              </div>
          </div>
          <div className={`profile-info ${profileInfo === "open" ? "open" : ""}`}>
              <SidebarItem1 icon={<FontAwesomeIcon icon={faHandHoldingDollar} />} label="Add funds" isActive={(title === "Deposit")?true:false} link="/deposit" />
              <SidebarItem1 icon={<FontAwesomeIcon icon={faSackDollar} />} label="Withdraw funds" isActive={(title === "Withdraw")?true:false} link="/withdraw" />
              <SidebarItem1 icon={<FontAwesomeIcon icon={faGear} />} label="Settings" isActive={(title === "Settings")?true:false} onClick={() => {toggleSettingsBar()}} />
              <SidebarItem1 icon={<FontAwesomeIcon icon={faBell} />} label="Notifications" isActive={(title === "Notifications")?true:false} onClick={toggleNotification}/>
              <SidebarItem1 icon={<FontAwesomeIcon icon={faArrowRightFromBracket} />} label="Logout" isActive={(title === "Logout")?true:false} onClick={logout} />
          </div>
      </header>
    </>
  );
}

export default Header;